export default __webpack_public_path__ + "images/financial-account-hover.svg";